import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { trackPageView } from "./lib/tracking";
import Home from "./pages/Home";
import Jobs from "./pages/Jobs";
import JobDetail from "./pages/JobDetail";
import Auth from "./pages/Auth";
import CandidateDashboard from "./pages/CandidateDashboard";
import CompanyDashboard from "./pages/CompanyDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import CompanyPublic from "./pages/CompanyPublic";
import NotFound from "./pages/NotFound";
import JobsByLocation from "./pages/JobsByLocation";
import JobsByCategory from "./pages/JobsByCategory";
import Legal from "./pages/Legal";
import CasesStudy from "./pages/CasesStudy";
import { CookieBanner } from "./components/CookieBanner";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/empregos" element={<Jobs />} />
          <Route path="/empregos/:slug" element={<JobDetail />} />
          <Route path="/empresas/:slug" element={<CompanyPublic />} />
          <Route path="/empregos-em/:slug" element={<JobsByLocation />} />
          <Route path="/empregos-de/:slug" element={<JobsByCategory />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="/casos-de-estudo" element={<CasesStudy />} />
          <Route path="/candidato" element={<CandidateDashboard />} />
          <Route path="/empresa" element={<CompanyDashboard />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
